import * as Yup from 'yup';

export const filterWebhookSchema = Yup.object().shape({
  url: Yup.string().url('Por favor insira uma URL válida'),
  name: Yup.string(),
});
